import React from 'react';
import { Mail, RefreshCw, Globe2 } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export const Problem = () => {
  const useCases = [{
    icon: <Mail className="text-zano-pink" size={24} data-id="element-1728" />,
    title: 'Reach the talent you want, instantly',
    desc: "Have an A-list creator or celebrity in mind? Search their name in Zano and get their talent manager's direct email right away — you're one message from a conversation."
  }, {
    icon: <RefreshCw className="text-blue-500" size={24} data-id="element-1729" />,
    title: 'Live rosters from your agency partners',
    desc: 'For the agencies you already partner with, their rosters and performance data stay live in Zano — kept current by the agencies themselves, with performance and audience data built in and ready at a glance.'
  }, {
    icon: <Globe2 className="text-purple-500" size={24} data-id="element-1730" />,
    title: 'Source from team-vetted agencies worldwide',
    desc: 'Every agency is personally vetted by our team — we meet with them before they can create an account and check in regularly. Discover hundreds of verified agencies and their represented creators across the US, UK, Europe, Asia, and the UAE.'
  }];
  return <section className="py-24 bg-white" data-id="element-1731">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1732">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1733">
          <h2 className="text-3xl md:text-4xl font-bold text-zano-charcoal mb-4" data-id="element-1734">
            A live, breathing database of represented talent
          </h2>
          <p className="text-lg text-gray-600" data-id="element-1735">
            Zano gives brands and marketing agencies a scalable way to source
            from talent agencies — making it fast and easy to find represented
            creators and partner with vetted agencies, all from one live,
            searchable network.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1736">
          {useCases.map((point, idx) => <Reveal key={idx} delay={idx * 0.08} className="h-full" data-id="element-1737">
              <div className="h-full bg-gray-50 rounded-2xl p-6 border border-gray-100 hover:border-zano-pink/40 hover:shadow-float hover:-translate-y-1 transition-all duration-300" data-id="element-1738">
                <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center mb-4 border border-gray-100" data-id="element-1739">
                  {point.icon}
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1740">
                  {point.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-1741">
                  {point.desc}
                </p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
};